import React, { Component, Fragment, Children } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';

// Components
import DroppableWorkspaceSection from '../droppableWorkspaceSection/DroppableWorkspaceSection';
import WorkspaceContext from './WorkspaceContext';

// Utils
import { needsFiller } from './utils';
import { JSSClasses } from '../../proptypes/jss-prop-types';

// Styles
import styles from './workspaceGroup.styles';

export class WorkspaceGroupComponent extends Component {
  static defaultProps = {
    children: [],
    classes: {},
    className: '',
    onUpdate() {}
  };

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})])),
      PropTypes.node,
      PropTypes.shape({})
    ]),
    classes: JSSClasses,
    className: PropTypes.string,
    onUpdate: PropTypes.func
  };

  state = {};

  updateWorkspace(userPrefs) {
    this.props.onUpdate(userPrefs);
    this.setState({ userPrefs });
  }

  handleDrop = (currentRow, dropRow, size) => {
    /** @description cloning userPrefs */
    const oldRows = [].concat(this.props.children).slice(0);
    const widget = oldRows.splice(currentRow, 1)[0];
    if (!widget) {
      return;
    }

    const moving = {
      ...widget,
      props: {
        ...widget.props,
        size
      }
    };
    oldRows.splice(dropRow, 0, moving);
    const userPrefs = oldRows.map((widget, index) => ({ ...widget, rowNumber: index }));

    this.updateWorkspace(userPrefs);
  };

  handleRemove = (id) => {
    const userPrefs = []
      .concat(this.props.children)
      .slice(0)
      .filter((widget) => widget.props.id !== id);

    this.updateWorkspace(userPrefs);
  };

  handleResize = (id, size) => {
    const userPrefs = []
      .concat(this.props.children)
      .slice(0)
      .map((widget) => ({
        ...widget,
        props: {
          ...widget.props,
          size: widget.props.id === id ? size : widget.props.size
        }
      }));

    this.updateWorkspace(userPrefs);
  };

  handleChildren = (children) =>
    Children.map(children, (component, index) => {
      const props = {
        ...component.props,
        rowNumber: index,
        /** @description Example for extensibility
         * @example
            onDrop: (...args) => {
              this.handleDrop(...args);
                if (component.props.onDrop) {
                  component.props.onDrop(...args);
                }
            }
         */
        onDrop: this.handleDrop,
        onRemove: this.handleRemove,
        onResize: this.handleResize
      };

      return React.cloneElement(component, props);
    });

  render() {
    const {
      className,
      classes: { narrow, workspaceGroup }
    } = this.props;
    const children = this.handleChildren(this.props.children);
    const childrenProps = Children.map(children, ({ props }) => props);

    return (
      <div className={`${className} ${workspaceGroup}`}>
        {children.map((Component, index) => (
          <Fragment key={`${Component.props.rowNumber}`}>
            {Component}
            {needsFiller(childrenProps, index) && (
              <div className={`${narrow}`}>
                <DroppableWorkspaceSection
                  row={Component.props.rowNumber + 1}
                  key={`${Component.props.rowNumber}-filler`}
                  size="S"
                />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    );
  }
}

const styledWorkspace = withStyles(styles)(WorkspaceGroupComponent);
export default WorkspaceContext(styledWorkspace);
